import { RoundedIconButton } from '@/components/buttons/Buttons';
import { Chip } from 'primereact/chip';
import { Panel } from 'primereact/panel';
import { MdOutlineDelete, MdStar, MdStarOutline } from 'react-icons/md';
import styles from './add-card-item.module.css';

type Props = {
	item: {
		id: number;
		number: string;
		exp: string;
		cardType?: string;
		isDefault?: boolean;
	};
	onDelete?: (id: number) => void;
	onSetDefault?: (id: number) => void;
};

const AddCardItem = ({ item, onDelete, onSetDefault }: Props) => {
	const handleDelete = () => {
		if (onDelete) {
			onDelete(item.id);
		}
	};

	return (
		<Panel className={styles.container}>
			<div className={styles['item-content']}>
				<div className="item-name flex items-center">
					{item.cardType && <span className="capitalize mr-2">{item.cardType}</span>}
					<span>{item.number}</span>
					{item.isDefault && <Chip label="Default" className={styles.defaultChip} />}
				</div>
				<p className={styles.date}>Expiry date: {item.exp}</p>
			</div>
			<div className="item-actions flex items-center gap-1">
				{onSetDefault && (
					<RoundedIconButton
						id="item-set-default"
						icon={item.isDefault ? MdStar : MdStarOutline}
						iconSize="24"
						className="secondary"
						disabled={item.isDefault}
						onClick={() => onSetDefault(item.id)}
					/>
				)}
				<RoundedIconButton
					id="item-delete"
					icon={MdOutlineDelete}
					iconSize="24"
					className="secondary"
					onClick={handleDelete}
				/>
			</div>
		</Panel>
	);
};

export default AddCardItem;
